const mergeRoutes = (routes, additional) => {
  return additional.reduce((acc, route) => {
    const existingRouteIndex = acc.findIndex((r) => r.path === route.path);
    if (existingRouteIndex > -1) {
      acc[existingRouteIndex] = route;
    } else {
      acc.push(route);
    }
    return acc;
  }, routes);
};
const filterRoutes = (route) => !!(route == null ? void 0 : route.element);
export {
  filterRoutes,
  mergeRoutes
};
